export default "__VITE_ASSET__6058dad7__"